//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/control.proto (package dxos.mesh.teleport.control, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/control.proto.
 */
export const file_dxos_mesh_teleport_control: GenFile = /*@__PURE__*/
  fileDesc("CiBkeG9zL21lc2gvdGVsZXBvcnQvY29udHJvbC5wcm90bxIaZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wiKAoYUmVnaXN0ZXJFeHRlbnNpb25SZXF1ZXN0EgwKBG5hbWUYASABKAkiUAoXQ29udHJvbEhlYXJ0YmVhdFJlcXVlc3QSNQoRcmVxdWVzdF90aW1lc3RhbXAYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIlEKGENvbnRyb2xIZWFydGJlYXRSZXNwb25zZRI1ChFyZXF1ZXN0X3RpbWVzdGFtcBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAy6wEKDkNvbnRyb2xTZXJ2aWNlEmEKEVJlZ2lzdGVyRXh0ZW5zaW9uEjQuZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wuUmVnaXN0ZXJFeHRlbnNpb25SZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EnYKCUhlYXJ0YmVhdBIzLmR4b3MubWVzaC50ZWxlcG9ydC5jb250cm9sLkNvbnRyb2xIZWFydGJlYXRSZXF1ZXN0GjQuZHhvcy5tZXNoLnRlbGVwb3J0LmNvbnRyb2wuQ29udHJvbEhlYXJ0YmVhdFJlc3BvbnNlYgZwcm90bzM", [file_google_protobuf_empty, file_google_protobuf_timestamp]);

/**
 * @generated from message dxos.mesh.teleport.control.RegisterExtensionRequest
 */
export type RegisterExtensionRequest = Message<"dxos.mesh.teleport.control.RegisterExtensionRequest"> & {
  /**
   * / Must not contain slashes: /[\w_.]+/. Example: `dxos.mesh.teleport.control`.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message dxos.mesh.teleport.control.RegisterExtensionRequest.
 * Use `create(RegisterExtensionRequestSchema)` to create a new message.
 */
export const RegisterExtensionRequestSchema: GenMessage<RegisterExtensionRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_control, 0);

/**
 * @generated from message dxos.mesh.teleport.control.ControlHeartbeatRequest
 */
export type ControlHeartbeatRequest = Message<"dxos.mesh.teleport.control.ControlHeartbeatRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp request_timestamp = 1;
   */
  requestTimestamp?: Timestamp;
};

/**
 * Describes the message dxos.mesh.teleport.control.ControlHeartbeatRequest.
 * Use `create(ControlHeartbeatRequestSchema)` to create a new message.
 */
export const ControlHeartbeatRequestSchema: GenMessage<ControlHeartbeatRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_control, 1);

/**
 * @generated from message dxos.mesh.teleport.control.ControlHeartbeatResponse
 */
export type ControlHeartbeatResponse = Message<"dxos.mesh.teleport.control.ControlHeartbeatResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp request_timestamp = 1;
   */
  requestTimestamp?: Timestamp;
};

/**
 * Describes the message dxos.mesh.teleport.control.ControlHeartbeatResponse.
 * Use `create(ControlHeartbeatResponseSchema)` to create a new message.
 */
export const ControlHeartbeatResponseSchema: GenMessage<ControlHeartbeatResponse> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_control, 2);

/**
 * / Controls the lifycycle of the teleport session and its exentsions.
 *
 * @generated from service dxos.mesh.teleport.control.ControlService
 */
export const ControlService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.control.ControlService.RegisterExtension
   */
  registerExtension: {
    methodKind: "unary";
    input: typeof RegisterExtensionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc dxos.mesh.teleport.control.ControlService.Heartbeat
   */
  heartbeat: {
    methodKind: "unary";
    input: typeof ControlHeartbeatRequestSchema;
    output: typeof ControlHeartbeatResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_control, 0);

